/** Service Desk console: listahan ng mga Ticket at mga view, Bagong ticket (C01, SD-S1-43). */
export const serviceTickets = {
  subtitle: "Lahat ng hiniling ng mga kliyente mo, sa iisang pila. Pumili ng view, mag-filter, at gamitin ang",
  newTicket: "Bagong ticket",
  loading: "Naglo-load ng mga ticket",
  noOrganisation: "Walang organisasyon",
  unassigned: "Walang nakatalaga",
  units: { minute: "min", hour: "oras", day: "araw" },
  sla: { pausedWaiting: "naghihintay sa kliyente", pausedOnHold: "naka-hold" },
  views: {
    label: "Mga view ng ticket",
    title: "Mga view",
    saved: "Mga naka-save na view",
    shared: "Ibinahagi",
    unassigned: "Walang nakatalaga",
    my_open: "Aking bukas",
    my_team: "Aking team",
    teamNamed: "Aking team ({{name}})",
    waiting_client: "Naghihintay sa kliyente",
    breaching_soon: "Malapit nang lumampas",
    all_open: "Lahat ng bukas",
    resolved: "Nalutas",
    closed: "Sarado",
    note: "Kinukuwenta ang bilang mula sa mga ticket na nakikita mo.",
    delete: "Burahin ang view na {{name}}",
    deleted: "Nabura ang view na “{{name}}”",
  },
  search: {
    label: "Maghanap ng ticket",
    placeholder: "Hanapin ang numero, pamagat, organisasyon, humihiling…",
    clear: "I-clear ang paghahanap",
  },
  filters: {
    button: "Mga filter",
    title: "I-filter ang mga ticket",
    active_one: "{{count}} filter ang naka-on",
    active_other: "{{count}} filter ang naka-on",
    clearAll: "I-clear lahat",
    status: "Status",
    priority: "Priyoridad",
    type: "Uri",
    team: "Team",
    assignee: "Nakatalaga",
    organisation: "Organisasyon",
    tag: "Tag",
    anyStatus: "Anumang status",
    anyPriority: "Anumang priyoridad",
    anyType: "Anumang uri",
    anyTeam: "Anumang team",
    anyone: "Sinuman",
    anyOrganisation: "Anumang organisasyon",
    me: "Ako",
    remove: "Alisin ang filter na {{filter}}",
    lockedByView: "Itinakda ng view na “{{view}}”",
  },
  columnsButton: "Mga column",
  columnsLabel: "Mga nakikitang column",
  columnsReset: "I-reset",
  columnsAlways: "(palagi)",
  columns: {
    number: "Ticket",
    title: "Pamagat",
    org: "Organisasyon",
    requester: "Humihiling",
    type: "Uri",
    status: "Status",
    priority: "Priyoridad",
    assignee: "Nakatalaga",
    sla: "SLA",
    updated: "Na-update",
    created: "Ginawa",
  },
  table: {
    label: "Mga ticket",
    selectAll_one: "Piliin ang {{count}} nai-load na ticket",
    selectAll_other: "Piliin ang lahat ng {{count}} nai-load na ticket",
    select: "Piliin ang {{number}}",
    focused: "{{number}}, {{position}} sa {{count}}",
  },
  foot: {
    showing_one: "Ipinapakita ang {{shown}} sa {{total}} ticket",
    showing_other: "Ipinapakita ang {{shown}} sa {{total}} ticket",
    sorted: "nakaayos ayon sa {{column}} ({{order}})",
    asc: "pataas",
    desc: "pababa",
    loadMore: "Mag-load pa",
  },
  bulk: {
    label: "Mga pangkatang aksyon",
    selected_one: "{{count}} ang napili",
    selected_other: "{{count}} ang napili",
    assign: "Italaga",
    assignMe: "Italaga sa akin",
    unassign: "Alisin ang nakatalaga",
    status: "Status",
    statusHint: "Ilipat sa",
    priority: "Priyoridad",
    addTag: "Magdagdag ng tag",
    tagLabel: "Tag",
    applyTag: "Idagdag sa mga ticket",
    merge: "Pagsamahin",
    mergeHint: "Pumili ng eksaktong dalawang bukas na ticket ng iisang organisasyon para pagsamahin",
    clear: "I-clear",
    done_one: "Na-update ang {{count}} ticket",
    done_other: "Na-update ang {{count}} ticket",
    partial: "Na-update ang {{changed}}. Nilaktawan ang {{skipped}} (hindi valid na galaw mula sa kasalukuyang status), at hindi napalitan ang {{failed}}.",
  },
  empty: {
    clear: "I-clear ang mga filter",
    filteredTitle: "Walang ticket na tugma sa mga filter",
    filteredHint: "Subukang alisin ang isang filter o maghanap ng iba.",
    unassigned: { title: "Walang naghihintay ng may-ari", hint: "May nakatalaga na sa bawat bukas na ticket." },
    my_open: { title: "Walang bukas na ticket na nakatalaga sa iyo", hint: "Kumuha ng isa mula sa Walang nakatalaga, o tingnan ang view ng team mo." },
    my_team: { title: "Malinis ang pila ng team mo", hint: "Walang bukas na ticket para sa team mo ngayon." },
    waiting_client: { title: "Walang naghihintay sa kliyente", hint: "Lalabas dito ang mga ticket na itinakda mong Naghihintay sa kliyente." },
    breaching_soon: { title: "Walang ticket na malapit nang lumampas — ayos!", hint: "Lalabas dito ang mga ticket na malapit sa limit ng SLA, pinakamadalian muna." },
    all_open: { title: "Walang bukas na ticket", hint: "Dito papasok ang mga bagong ticket mula sa widget, e-mail at Messenger." },
    resolved: { title: "Walang nalutas na ticket", hint: "Nananatili rito ang mga nalutas na ticket hanggang kumpirmahin ng kliyente o awtomatikong magsara." },
    closed: { title: "Walang saradong ticket", hint: "Iniingatan ang mga sarado at kinanselang ticket para sa pag-uulat." },
    saved: { title: "Wala pang laman ang view na ito", hint: "Walang ticket na tugma sa naka-save na view na ito ngayon." },
  },
  error: { title: "Hindi namin ma-load ang mga ticket mo", body: "May nangyaring mali sa panig namin. Pakisubukan ulit." },
  saveView: {
    button: "I-save ang view",
    title: "I-save ang view na ito",
    name: "Pangalan",
    placeholder: "hal. Water systems ngayong linggo",
    nameShort: "Maglagay ng pangalang hindi bababa sa {{min}} character.",
    share: "Ibahagi sa team ko ({{team}})",
    shareHint: "Personal bilang default. Makikita ng mga ka-team mo ang ibinahaging view sa kanilang rail.",
    summary_one: "Isinasave ang {{count}} filter sa ibabaw ng view na “{{view}}”.",
    summary_other: "Isinasave ang {{count}} filter sa ibabaw ng view na “{{view}}”.",
    summarySearch: "Isinasave rin ang paghahanap na “{{q}}”.",
    cancel: "Kanselahin",
    save: "I-save ang view",
    saved: "Na-save ang view na “{{name}}”",
  },
  shortcuts: {
    button: "Mga shortcut",
    title: "Mga keyboard shortcut",
    hint: "Gumagana ang mga ito kapag hindi ka nagta-type sa isang field.",
    next: "Susunod na ticket",
    prev: "Nakaraang ticket",
    open: "Buksan ang ticket",
    select: "Piliin o alisin sa pagpili ang ticket",
    reply: "Sagutin ang kliyente",
    note: "Magdagdag ng panloob na tala",
    assign: "Italaga",
    status: "Palitan ang status",
    macro: "Maglagay ng macro",
    new: "Bagong ticket",
    search: "Maghanap sa listahan",
    help: "Ipakita ang listahang ito",
    clear: "I-clear ang pinili",
  },
  new: {
    assetPicker: {
      needsOrganisation: "Piliin muna ang requester: ang kagamitang ipinapakita ay sa organisasyon ng requester lang.",
      search: "Hanapin ang kagamitan ng organisasyon",
      searchLabel: "Maghanap ng kagamitan",
      error: "Hindi ma-load ang kagamitan. Subukan muli.",
      notListed: "Wala sa listahan",
      narrow: "Ipinapakita ang {{shown}} sa {{total}}. Mag-type para paliitin ang listahan.",
      linkFailed: "Nagawa ang ticket, pero hindi maikabit dito ang kagamitan.",
    },
    dialogTitle: "Bagong ticket",
    dialogHint: "Ginawa para sa kliyente (tawag, walk-in o ipinasang e-mail). Itatalaga ito ng mga routing rule gaya ng ibang ticket.",
    requester: "Humihiling",
    requesterHint: "Hanapin ayon sa pangalan o e-mail.",
    requesterPlaceholder: "Maghanap ng contact…",
    contactResults: "Mga tugmang contact",
    contactNone: "Walang tugmang contact. Idagdag siya bilang bagong contact sa ibaba.",
    contactError: "Hindi ma-load ang mga contact. Maaari mong idagdag ang tao bilang bagong contact.",
    changeContact: "Palitan",
    addNew: "Magdagdag ng bagong contact",
    useExisting: "Pumili ng umiiral na contact",
    newName: "Pangalan",
    newEmail: "E-mail",
    newEmailHint: "Opsyonal. Kung wala nito, hindi maaabisuhan ang kliyente.",
    organisation: "Organisasyon",
    type: "Uri",
    priority: "Priyoridad",
    title: "Pamagat",
    titleHint: "Maikli at tiyak na buod. Makikita ng kliyente ang pamagat na ito.",
    titlePlaceholder: "Ano ang problema o hiling?",
    description: "Paglalarawan",
    descriptionPlaceholder: "Ang sinabi ng kliyente. I-paste ang e-mail o idagdag ang tala mo sa tawag.",
    assignee: "Italaga kay",
    autoRoute: "Auto-route (routing rules ang magpapasya)",
    routingGeneric: "Itatalaga ng mga routing rule ang ticket na ito sa isang team o tao kapag ginawa ito.",
    routingRule: "Rule #{{number}} {{name}} → {{where}}.",
    routingQueue: "pila ng team",
    notify: "Padalhan ang kliyente ng e-mail ng kumpirmasyon",
    notifyHint: "Maaabisuhan lang ang kliyente sa mga ticket na ginawa ng staff kung naka-tick ito.",
    cancel: "Kanselahin",
    create: "Gumawa ng ticket",
    created: "Nagawa ang ticket na {{number}}",
    typesError: "Hindi ma-load ang mga uri ng ticket",
    noTypes: "Wala pang uri ng ticket para sa mga hiling ng kliyente. Magpabukas ng isa sa administrator sa Settings ng Serbisyo.",
    errors: {
      requester: "Piliin kung para kanino ang ticket na ito.",
      newName: "Ilagay ang pangalan ng tao.",
      newEmail: "Maglagay ng wastong e-mail address.",
      type: "Pumili ng uri.",
      title: "Maglagay ng pamagat na hindi bababa sa {{min}} character.",
      field: "Kailangan ang field na ito.",
    },
  },
  live: { connecting: "Kumokonekta", live: "Live", reconnecting: "Muling kumokonekta" },
  export: {
    button: "I-export ang CSV",
    done: "Na-export ang {{count}} ticket sa {{file}}",
    truncated: "Ang unang 10,000 ticket lang ang laman ng file. Paliitin ang view gamit ang filter para ma-export ang iba.",
    widened: "Masyadong mahaba ang mga filter mo para maipadala, kaya ang buong view ang na-export.",
  },
} as const;
